export default "__VITE_ASSET__e6c6c48b__"